import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Version tracking - visible in console (v3)
const VERSION = import.meta.env.VITE_DEPLOY_VERSION ?? 'dev';
console.log('[Swapper] Loading version:', VERSION);

// Global error handler for window
window.onerror = function (message, source, lineno, colno, error) {
  console.error('[Swapper] Uncaught error:', message, source, lineno, colno, error);
  return false;
};

window.addEventListener('error', (e) => {
  console.error('[Swapper] Window error event:', e.error);
});

// Ensure app renders even if extensions throw errors
const rootElement = document.getElementById('root');
console.log('[Swapper] Root element:', rootElement);
if (!rootElement) {
  console.error('[Swapper] No root element found');
} else {
  try {
    ReactDOM.createRoot(rootElement as HTMLElement).render(
      // No React.StrictMode: its dev-only double-mount aborts the widget's in-flight
      // /v1/tokens query (react-query cancels on the throwaway unmount and never
      // refires it), leaving every token list empty in development.
      <App />,
    );
    console.log('[Swapper] Render complete');
  } catch (e) {
    console.error('[Swapper] Failed to render app:', e);
    // Fallback: render a simple message
    rootElement.innerHTML = '<div style="padding:20px;color:white">Failed to load app: ' + (e as Error).message + '</div>';
  }
}
